const highlights = [
  "MSc AI & Machine Learning",
  "First-Class BSc Computer Science",
  "IEEE-Published Research",
  "Four Major Competition Placements",
  "Based in Darmstadt, Germany",
] as const;

export function Highlights() {
  return (
    <section className="highlight-strip" aria-label="Professional highlights">
      <div className="shell highlight-track">
        {highlights.map((highlight, index) => (
          <div key={highlight}>
            <span>{String(index + 1).padStart(2, "0")}</span>
            <p>{highlight}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
